<template>
	<Transition name="fade">
		<div v-if="!isOnline" class="connection-status">
			<div class="status-icon">
				<WifiOffIcon />
			</div>
			<div class="status-text">
				<div class="status-title">Нет соединения</div>
				<div class="status-subtitle">Запросы будут отправлены при восстановлении</div>
			</div>
		</div>
	</Transition>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
	name: 'ConnectionStatus',

	setup() {
		const isOnline = ref(navigator.onLine)

		function handleOnline() {
			isOnline.value = true
			console.log('🌐 [ConnectionStatus] Соединение восстановлено')
		}

		function handleOffline() {
			isOnline.value = false
			console.log('📡 [ConnectionStatus] Соединение потеряно')
		}

		onMounted(() => {
			window.addEventListener('online', handleOnline)
			window.addEventListener('offline', handleOffline)
		})

		onUnmounted(() => {
			window.removeEventListener('online', handleOnline)
			window.removeEventListener('offline', handleOffline)
		})

		return {
			isOnline,
		}
	},

	components: {
		WifiOffIcon: {
			template: `
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<line x1="1" y1="1" x2="23" y2="23"></line>
					<path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
					<path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
					<path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
					<path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
					<path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
					<line x1="12" y1="20" x2="12.01" y2="20"></line>
				</svg>
			`
		}
	}
}
</script>

<style scoped>
.connection-status {
	position: fixed;
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 20px;
	background: #fee2e2;
	color: #dc2626;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	z-index: 10000;
	min-width: 300px;
}

.status-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	background: #fecaca;
	border-radius: 50%;
	flex-shrink: 0;
}

.status-text {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.status-title {
	font-size: 14px;
	font-weight: 600;
	line-height: 1.2;
}

.status-subtitle {
	font-size: 12px;
	opacity: 0.8;
	line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
